import Navigation from '@martyrs/src/modules/core/views/components/partials/Navigation.vue'
import { navigationItems } from '../configs/navigation.backoffice.config.js'
import SidebarUser from '@martyrs/src/modules/auth/views/components/partials/SidebarUser.vue'

export function getRoutes(options = {}) {
  const route = options.route || 'Home';
  const routes = [];

  routes.push({
    parentName: route,
    config: {
      basePath: 'backoffice',
      routes: [
        {
          path: '',
          name: 'Backoffice Root',
          meta: {
            sidebar_navigation: Navigation,
            sidebar_navigation_items: navigationItems,
            sidebar_footer_component: SidebarUser,
            context: 'backoffice',
            // Снимаем лендинг-меты, унаследованные от родителя Home: у бекофиса
            // свой сайдбар и НЕ должно быть overlay-хедера / landing-навигации
            // (те же ключи, что у проектного /dashboard).
            // Свёрнутая ширина — рельса w-3r: квадрат пункта меню (w-max-semi, 2.5rem)
            // плюс паддинги контейнера навигации (pd-micro с двух сторон).
            sidebar_width_hidden: 'w-3r',
            header_mode: null,
            header_navigation: null,
            header_navigation_items: null,
            sidebarOpenOnEnter: true,
            sidebarCloseOnLeave: true,
            // header_scroll_class снимаем тоже: иначе после прокрутки хедер
            // бекофиса подхватывал бы капсулу лендинга.
            header_class: 'br-b-1px br-subtle',
            header_scroll_class: null,
            // Колокольчик уведомлений в хедере; меню профиля не показываем —
            // пользователь живёт в футере сайдбара (SidebarUser).
            header_show_notifications: true,
            header_notifications_class: 'button--card button--m bs-regular',
            header_notifications_icon_class: 'i-regular',
            header_show_profile: false,
            // Многоуровневый лейаут: сайдбар на бекдропе, страница — приподнятая
            // панель (.page-panel). Тот же набор, что у проектного /dashboard.
            page_elevated: true,
          },
          props: {
            newsletterPopup: 12344,
          },
          beforeEnter: [
            async (to, from, next) => {
              const { requiresAdmin } = await import(/* webpackChunkName: "auth-validation" */ '@martyrs/src/modules/auth/views/middlewares/auth.validation.js');
              requiresAdmin(to, from, next);
            },
          ],
          children: [
            {
              path: '',
              name: 'Backoffice Admin',
              meta: {
                title: 'backoffice.title',
              },
              component: () => import(/* webpackChunkName: 'BackofficeGallery' */ '../components/pages/Dashboard.vue'),
            },
          ],
        }
      ],
    }
  });

  return routes;
}
